import { Injectable } from '@angular/core';
import { AppEvent } from '@models/events/app-event.enum';
import { EventData } from '@models/events/event-data.model';
import { EventInterface } from '@models/events/event.interface';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private subject$ = new Subject<EventInterface>();

  constructor() { }

  emit(event: EventData) {
    this.subject$.next(event);
  }

  on(eventName: AppEvent, action?: any): Subscription {
    return this.subject$.pipe(
      filter((e: EventInterface) => e.name === eventName),
      map( (e: EventInterface) => e["value"])).subscribe(action);
  }
}
